<template>
    <v-container>
      <div class="mb-5">
        <material-card color="primary" title="Ubah Pengaturan Eksternal" class="card-wrapper">
          <v-form>
            <v-row>
              <div class="form-input mt-5 mb-3">
                <p style="color: red">* Wajib Diisi</p>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama<span style="color: red">*</span></p>
                  <v-text-field
                    dense 
                    placeholder="Nama" 
                    required 
                    outlined 
                    v-model="formData.nama_app"
                    @input="$v.formData.nama_app.$touch()"
                    @blur="$v.formData.nama_app.$touch()"
                    :error-messages="namaErrors"
                  />
                  <span style="color:red;">{{errorMessageNama}}</span>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Secret Key<span style="color: red">*</span></p>
                  <v-text-field
                    dense 
                    placeholder="Secrey Key" 
                    required 
                    outlined 
                    v-model="formData.secret_key"
                    @input="$v.formData.secret_key.$touch()"
                    @blur="$v.formData.secret_key.$touch()"
                    :error-messages="secretkeyErrors"
                   
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Call Back<span style="color: red">*</span></p>
                  <v-text-field
                    dense 
                    placeholder="Call Back" 
                    required 
                    outlined 
                    v-model="formData.call_back"
                    @input="$v.formData.call_back.$touch()"
                    @blur="$v.formData.call_back.$touch()"
                    :error-messages="callbackErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Whitelist IP<span style="color: red">*</span></p>
                  <p><i>Pisahkan menggunakan tanda koma<b>(,)</b></i></p>
                  <v-textarea 
                    dense
                    placeholder="Whitelist IP"
                    required
                    outlined
                    v-model="formData.whitelist_ip"
                    @input="$v.formData.whitelist_ip.$touch()"
                    @blur="$v.formData.whitelist_ip.$touch()"
                    :error-messages="whitelistErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar AuthConfig</p>
                  <v-textarea
                    dense
                    placeholder="AuthConfig"
                    outlined
                    v-model="formData.auth_config"
                    @input="$v.formData.auth_config.$touch()"
                    @blur="$v.formData.auth_config.$touch()"
                    :error-messages="authConfigErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Header Config</p>
                  <v-textarea
                    dense
                    placeholder="Header Config"
                    outlined
                    v-model="formData.header_config"
                    @input="$v.formData.header_config.$touch()"
                    @blur="$v.formData.header_config.$touch()"
                    :error-messages="header_configErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Daftar Body Config</p>
                  <v-textarea
                    dense
                    placeholder="Body Config"
                    outlined
                    v-model="formData.body_config"
                    @input="$v.formData.body_config.$touch()"
                    @blur="$v.formData.body_config.$touch()"
                    :error-messages="body_configErrors"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Keterangan<span style="color: red">*</span></p>
                  <v-textarea
                    dense
                    placeholder="Keterangan"
                    required
                    outlined
                    v-model="formData.keterangan"
                    @input="$v.formData.keterangan.$touch()"
                    @blur="$v.formData.keterangan.$touch()"
                    :error-messages="keteranganErrors"
                  />
                </div>
              </v-col>

              <v-col cols="12" class="text-right">
                <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp
                <v-btn color="primary" @click="updateData()">Simpan</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
            {{ snackbarText }}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
        </material-card>
      </div>

    </v-container>
  </template>
  
  <script>
  import { apiServer } from "../../setup-axios";
  import { minLength, maxLength, helpers, required } from "vuelidate/lib/validators";
  const textregex = helpers.regex('textregex', /^[a-zA-Z0-9 .,'()&\/-]{2,255}$/i)
  const isJsonString = (str) => {
    if (str === '') return true;
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  export default {
    data: () => ({
      // items: ['Test 1', 'Test 2', 'Test 3'],
      formData: {
        app_id: "",
        nama_app:"",
        secret_key:"",
        call_back:"",
        whitelist_ip:"",
        auth_config:"",
        header_config:"",
        body_config:"",
        keterangan:"",
      },
      errorMessageNama:'',
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
    }), 
   
    validations: {
      formData: {
        nama_app: {
          required,
        //   textregex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        secret_key: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        call_back: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        whitelist_ip: {
          required,
          validIP: value => {
            if (!value) return false;
            const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/; 
            const ipv4Regex = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/
            const ips = value.split(',');
            console.log(ips)
            for (let ip of ips) {
              console.log(ip)
              if (!ipv6Regex.test(ip.trim()) && !ipv4Regex.test(ip.trim())) {
                console.log("false")
                return false
              }
            }
            return true
          },
        },
        auth_config: {
          minLength: minLength(3),
          isJsonString
        },
        header_config: {
          minLength: minLength(3),
          isJsonString
        },
        body_config: {
          minLength: minLength(3),
          isJsonString
        },
        keterangan: {
          required,
          minLength: minLength(3)
        },
      }
    },
    computed: {
      namaErrors() {
        const errors = [];
        if (!this.$v.formData.nama_app.$dirty) return errors;
        !this.$v.formData.nama_app.required &&
        errors.push("Nama harus diisi");
        !this.$v.formData.nama_app.minLength &&
        errors.push("Nama minimal 3 karakter");
        !this.$v.formData.nama_app.maxLength &&
        errors.push("Nama mmaximal 255 karakter");
        
        return errors;
      },
      secretkeyErrors() {
        const errors = [];
        if (!this.$v.formData.secret_key.$dirty) return errors;
        !this.$v.formData.secret_key.required &&
        errors.push("SecretKey harus diisi");
        !this.$v.formData.secret_key.minLength &&
        errors.push("Nama minimal 3 karakter");
        !this.$v.formData.secret_key.maxLength &&
        errors.push("Nama mmaximal 255 karakter");
        // errors.push("SecretKey hanya boleh mengandung huruf dan angka");
        
        return errors;
      },
      callbackErrors() {
        const errors = [];
        if (!this.$v.formData.call_back.$dirty) return errors;
        !this.$v.formData.call_back.required &&
        errors.push("Callback harus diisi");
        !this.$v.formData.call_back.minLength &&
        errors.push("Nama minimal 3 karakter");
        !this.$v.formData.call_back.maxLength &&
        errors.push("Nama mmaximal 255 karakter");
        return errors;
      },
      whitelistErrors() {
        const errors = [];
        if (!this.$v.formData.whitelist_ip.$dirty) return errors;
        !this.$v.formData.whitelist_ip.required &&
        errors.push("Whitelist harus diisi");
        !this.$v.formData.whitelist_ip.validIP &&
        errors.push("Format IP salah, harap diperbaiki sesuai format berikut: xxx.xxx.xxx.xxx,yyy.yyy.yyy.yyy,abcd:abcd:abcd:abcd, dst.");
        return errors;
      },
      auth_configErrors() {
        const errors = [];
        if (!this.$v.formData.auth_config.$dirty) return errors;
        !this.$v.formData.auth_config.minLength && errors.push("Auth Config minimal 3 karakter");
        !this.$v.formData.auth_config.isJsonString && errors.push("Auth Config harus berupa string JSON yang valid");
        return errors;
      },
      header_configErrors() {
        const errors = [];
        if (!this.$v.formData.header_config.$dirty) return errors;
        !this.$v.formData.header_config.minLength && errors.push("Header Config minimal 3 karakter");
        !this.$v.formData.header_config.isJsonString && errors.push("Header Config harus berupa string JSON yang valid");
        return errors;
      },
      body_configErrors() {
        const errors = [];
        if (!this.$v.formData.body_config.$dirty) return errors;
        !this.$v.formData.body_config.minLength && errors.push("Body Config minimal 3 karakter");
        !this.$v.formData.body_config.isJsonString && errors.push("Body Config harus berupa string JSON yang valid");
        return errors;
      },
      keteranganErrors() {
        const errors = [];
        if (!this.$v.formData.keterangan.$dirty) return errors;
        !this.$v.formData.keterangan.required && errors.push("Keterangan harus diisi");
        !this.$v.formData.keterangan.minLength && errors.push("Keterangan minimal 5 karakter");
        return errors;
      },
    },
    created() {
      console.log("loading")
      this.getData();
    },
    methods: {
      getData() {
        console.log("get data " + this.$route.params.app_id)
        apiServer
          .get("/pengaturan-eksternal/detail/" + this.$route.params.app_id)
          .then(response => {
            console.log(response.data.data)
            this.formData = response.data.data;
            console.log(this.formData)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      updateData() {
        this.$v.$touch()
        if (this.$v.$anyError) {
          return
        }
        let createData = new FormData()
        createData.append("Id",this.formData.app_id)
        createData.append("Nama",this.formData.nama_app.trim(" "))
        createData.append("SecretKey",this.formData.secret_key.trim(" "))
        createData.append("CallBack",this.formData.call_back.trim(" "))
        createData.append("WhitelistIp",this.formData.whitelist_ip.replace(/\n/g, ",").replace(/\r/g, "").replace(/ /g, ""))
        createData.append("AuthConfig",this.formData.auth_config.trim(" "))
        createData.append("HeaderConfig",this.formData.header_config.trim(" "))
        createData.append("BodyConfig",this.formData.body_config.trim(" "))
        createData.append("Keterangan",this.formData.keterangan.trim(" "))
        console.log('create', createData.nama)
        console.log('form',this.formData)
        apiServer
          .put("/pengaturan-eksternal/ubah", createData)
          .then(response => {
            console.log("update success: ", JSON.stringify(response))
            this.sendSnackbar("orange", "Pengaturan Eksternal  "+ this.formData.nama_app +" berhasil diubah");
            this.$router.push('/pengaturan-eksternal')
          })
          .catch(error => {
            console.log("There was an error:", error.response.data.message); // Logs out the error
            if (error.response.data.message.includes("sudah ada")){
              console.log("error edit nama")
              this.errorMessageNama = error.response.data.message
            } else {
              this.showSnackbar(
                "error",
                "Error, please contact your administrator!"
              );
            }
            
            
            // console.log(this.snackbar);
            // console.log(this.snackbarText);
            // console.log(this.snackbarColor);
          });
      },
      cancel() {
        this.$router.push('/pengaturan-eksternal')
      },
      sendSnackbar(color, message) {
        this.$store.dispatch('setSnackbar', {
          snackbarColor: color,
          snackbarText: message,
        })
      },
      showSnackbar(color, message) {
        console.log("snack " + color + " - " + message);
        this.snackbar = true;
        this.snackbarText = message;
        this.snackbarColor = color;
      },
    }
  }
</script>